import React, { useMemo } from "react";
import TodoHeader from "./TodoHeader";
import MyTodo from "./MyTodo";
import TodosHoc from "components/todos/hoc/TodosHoc";
import {
  listFormat
} from "components/todos/todoHelpers/constants";
import { datesWithYear } from "helper/methods";

const TodoBoard = props => {

  // We can get data from context using todoHoc from props like this
  const {
    todoState: { todos, activeSideList, lists, hideCompletedTask }
  } = props;
  const listData = useMemo(() => {
    // This method gives you a active sidelist data for showing name on todo header
    if (activeSideList) {
      if (activeSideList.id) {
        // It means if any custom list which made by users
        return lists.find(a => a.id === activeSideList.id);
      } else {
        // It means My day, Important and Bookmark list
        return { ...listFormat, ...activeSideList };
      }
    }
    return null;
  }, [activeSideList, lists]);

  const allTodos = useMemo(() => {
    // This method gives you todo list as per your need, all tasks or only that one which is not completed
    if (hideCompletedTask) {
      return todos.filter(a => !a.isComplete);
    }
    return todos;
  }, [todos, hideCompletedTask]);

  const filterTodos = useMemo(() => {
    // This method gives all todos active list wise

    if (activeSideList) {
      if (activeSideList.id) {
        return allTodos.filter(a => a.listId === activeSideList.id);
      } else {
        switch (activeSideList.title) {
          case "My Day":
            return allTodos.filter(
              a => datesWithYear(a.myDay) === datesWithYear(new Date())
            );
          case "Important":
            return allTodos.filter(a => a.isImportant);
          case "Bookmarked":
            return allTodos.filter(a => a.isBookmark);
          default:
            return [];
        }
      }
    }
    return [];
  }, [allTodos, activeSideList]);


  return (
    <div className="todo-board roe-box-shadow ml-10">
      <TodoHeader list={listData} />
      <div className="todo-container flex-y">
        {filterTodos &&
          filterTodos.map(todo => {
            return <MyTodo key={todo.id} todo={todo} />;
          })}
        <div className="backlines flex-1"></div>
      </div>
    </div>
  );
};

export default TodosHoc(TodoBoard);
